import { CircularProgress, FormControl, FormControlLabel, FormLabel, Switch } from '@mui/material';
import useConfig from 'hooks/useConfig';
import {
    usePutApiUserPreferencesMutation,
    useGetApiUserPreferencesParsedQuery,
} from 'store/userOrg/enhancedUserOrgApi';
import { ThemeMode } from 'types/config';

const ModeSelection = () => {
    const { mode, onChangeMode } = useConfig();
    const { data: preferences, isLoading: preferencesIsLoading } = useGetApiUserPreferencesParsedQuery();
    const [putPreferences] = usePutApiUserPreferencesMutation();

    const handleModeChange = () => {
        const newMode = mode === ThemeMode.LIGHT ? ThemeMode.DARK : ThemeMode.LIGHT;

        onChangeMode(newMode);

        putPreferences({
            body: {
                ...preferences,
                mode: newMode,
            },
        });
    };

    return (
        <FormControl>
            <FormLabel>Mode</FormLabel>
            {preferencesIsLoading ? (
                <CircularProgress />
            ) : (
                <FormControlLabel
                    control={<Switch onChange={handleModeChange} checked={mode === ThemeMode.DARK} />}
                    label={mode === ThemeMode.DARK ? 'Dark Mode on' : 'Light Mode on'}
                />
            )}
        </FormControl>
    );
};

export default ModeSelection;
